import React from "react";
import { Container, ContainerProps } from "react-bootstrap";
import Footer from "../marketing-site/footer/Footer";
import style from "../marketing-site/marketing-layout.module.scss";

const MarketingLayout: React.FC<ContainerProps> = ({ children, ...rest }) => {
  return (
    <>
      <Container {...rest}>{children}</Container>
      <div className={style.marketingSite}>
        <Footer />
      </div>
    </>
  );
};

export default MarketingLayout;
